/* eslint-disable react/jsx-no-undef */
import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperClass } from "swiper";
import { Navigation, Thumbs, FreeMode } from "swiper/modules";
import { getListBanner } from "../server/banner";
import { cleanUrl } from "../contants";
import { Skeleton } from "./Skeleton";

export interface TBanner {
  image: string;
  title: string;
  redirectUrl: string;
}

export default function SliderBar() {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperClass | null>(null);
  const [images, setImages] = useState<TBanner[]>([]);

  useEffect(() => {
    async function load() {
      try {
        const res = await getListBanner();
        const payload = res?.data ?? res;
        const data = Array.isArray(payload) ? payload : [];
        setImages(data);
      } catch (error) {
        console.error("Error loading banners:", error);
      }
    }
    load();
  }, []);

  if (!images.length) {
    return (
      <div className="h-full w-full">
        <div className="relative overflow-hidden rounded-2xl bg-white/5 shadow-xl ring-1 ring-white/10">
          <Skeleton className="h-[335px] w-full rounded-2xl bg-white/10" />
        </div>
        <div className="mt-3 grid grid-cols-4 gap-3 sm:grid-cols-6">
          {Array.from({ length: 6 }).map((_, idx) => (
            <Skeleton key={idx} className="h-8 w-full rounded-xl bg-white/10" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="h-full w-full">
      <div className="relative overflow-hidden rounded-2xl bg-white/5 shadow-xl ring-1 ring-white/10">
        <Swiper
          modules={[Navigation, Thumbs]}
          navigation
          thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
          className="mySwiper2 h-full min-h-[320px]"
          loop
        >
          {images?.map((item, index) => (
            <SwiperSlide key={index} className="!h-full">
              <a href={item.redirectUrl || "#"} className="relative block h-full w-full min-h-[335px]">
                <img
                  src={cleanUrl(item.image || "")}
                  className="absolute inset-0 h-full w-full object-cover"
                  alt={item.title || `Banner ${index + 1}`}
                  loading="lazy"
                />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

    <Swiper
        onSwiper={(swiper: any) => setThumbsSwiper(swiper)}
        modules={[FreeMode, Thumbs]}
        freeMode
        watchSlidesProgress
        slidesPerView={4}
        spaceBetween={12}
        breakpoints={{
          480: { slidesPerView: 5 },
          768: { slidesPerView: 6 },
        }}
        className="mySwiper mt-3"
      >
        {images.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="rounded-xl border border-white/10 bg-white/10 px-3 py-2 text-xs text-black/80 transition hover:text-black">
              {item.title || `Banner ${index + 1}`}
            </div>
          </SwiperSlide>
        ))}
      </Swiper> 
    </div>
  );
}
